/* eslint-disable react/no-unescaped-entities */
import React, { Component, Fragment } from 'react'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import Loader from '../Loader'
import TextDescription from '../TextDescription'
import Results from './Results'
import './index.sass'
import { resolutions } from '../../utils/constants'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

class Chonometer extends Component {
  state = {
    text: '',
    showGreatText: false,
    displayWidth: window.innerWidth,
    isMobile: false,
  }

  updateDimensions = () => {
    this.setState({ displayWidth: window.innerWidth })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentDidMount = () => {
    // const {
    //   chronoTexts,
    //   actions: { getChronometers },
    // } = this.props

    // if (chronoTexts.length === 0) {
    //   getChronometers()
    // }
    window.addEventListener('resize', this.updateDimensions)
  }

  onHandleChange = e => {
    this.setState({
      text: e.target.value,
    })
  }

  setGreatTextVisibility = (value) => {
    this.setState({
      showGreatText: value,
    })
  }

  render = () => {
    const { loading, t, lng } = this.props
    const { displayWidth, isMobile } = this.state
    const descrArray = lng === 'en'? [0,1,2,3] : [0,1]
    const translatedText = descrArray.map((_, ind) => t(`chonometer.texts.${ind}`))
    // const [showGreatText, setGreatTextVisibility] = useState(false)
    if (displayWidth < resolutions.tablet && !isMobile) {
      this.setState({isMobile: true})
    } else if (displayWidth >= resolutions.tablet && isMobile) {
      this.setState({isMobile: false})
    }
    return (
      <Fragment>
        <Helmet>
          <html lang={lng} />
          <title>{t('meta.chrono.title')}</title>
          <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/chronometer" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/chronometer" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/chronometer" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/chronometer" />
          <meta name="description" content={t('meta.chrono.descr')} />
          {lng === 'en' && <meta name="keywords" content={t('meta.chrono.keywords')} />}
          {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/chronometer'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/chronometer`} />}
          <meta property="og:title" content={t('meta.chrono.title')} />
          <meta property="og:description" content={t('meta.chrono.descr')} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en' ? 'https://unimedia.io/chronometer': `https://unimedia.io/${lng}/chronometer`} />
          <script type="application/ld+json">
          {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t('meta.chrono.descr')}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.chronometer')}"
              }]
            }]`}
          </script>
        </Helmet>
        <ScrollUpButton id={'chronometer'} />
        <div className="chono-page container overflow-y" id={'chronometer'}>
          <div className="container-wrapper">
          <Breadcrumbs pathname={window.location.pathname} color='white'/>
						<h1 className="main-title">{t('chonometer.title')}</h1>
            <div className="chrono-info">
              {loading ? <Loader /> : <TextDescription arrText={translatedText} />}
            </div>
            <div className="write-text-wrapper">
              <div className="write-text">
                <h6>{t('chonometer.subtitle')}</h6>
                <textarea onChange={this.onHandleChange} />
              </div>
              {this.state.showGreatText && isMobile &&
            <div className="write-text">
              <p>{lng === 'en'? <span>This fabulous text deserves to be recorded. Let's <a className='greatText' href={'/voices'}>voice over</a> it!</span> : lng === 'ru' ? <span>Этот потрясающий текст заслуживает того, чтобы быть записанным. Давайте <a className='greatText' href={'/voices'}>запишем</a>!</span> : <span>Dieser unglaubliche Text kann traumatisieren. <a className='greatText' href={'/voices'}>Schreiben</a> wir es auf!</span>}</p>
            </div>}
              <Results text={this.state.text} setGreatTextVisibility={this.setGreatTextVisibility} />
              
            </div>
            {this.state.showGreatText && !isMobile &&
            <div className="write-text">
              <p>{lng === 'en'? <span>This fabulous text deserves to be recorded. Let's <a className='greatText' href={'/voices'}>voice over</a> it!</span> : lng === 'ru' ? <span>Этот потрясающий текст заслуживает того, чтобы быть записанным. Давайте <a className='greatText' href={'/voices'}>запишем</a>!</span> : <span>Dieser unglaubliche Text kann traumatisieren. <a className='greatText' href={'/voices'}>Schreiben</a> wir es auf!</span>}</p>
            </div>}
            
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.app.loading,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Chonometer)
)
